import { render, staticRenderFns } from "./ruleItem.vue?vue&type=template&id=643ff8f6&"
import script from "./ruleItem.vue?vue&type=script&lang=js&"
export * from "./ruleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports